module.exports = __webpack_public_path__ + "img/banner.44040ac7.png";